import React, { useEffect, useState } from "react";
import { Modal } from "@material-ui/core";
import styles from "./BulkReassignVendingControllersModal.module.scss";
import Button from "../../button/Button";
import AsyncSelect from "react-select/async";
import _ from "lodash";
import { toast } from "react-toastify";
import { CloseIcon } from "../../../assets";
import fiscalDeviceService from "../../../apis/services/admin/fiscalDeviceService";
import vendingControllersService from "../../../apis/services/admin/vendingControllersService";

const toOption = (fiscalDevice) => {
  const suffix = [
    fiscalDevice?.businessUnit?.company?.name,
    fiscalDevice?.businessUnit?.address?.name,
  ]
    .filter(Boolean)
    .join(" / ");
  return {
    value: fiscalDevice,
    label: suffix ? `${fiscalDevice.name} — ${suffix}` : fiscalDevice.name,
  };
};

const BulkReassignVendingControllersModal = ({
  modalOpen,
  onClose,
  selectedControllers,
  onSuccess,
}) => {
  const [fiscalDevice, setFiscalDevice] = useState(null);
  const [fiscalDeviceOptions, setFiscalDeviceOptions] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (modalOpen) {
      const loadDefaultOptions = async () => {
        try {
          const { data } = await fiscalDeviceService.fetchFiscalDevices(1, 15, "");
          setFiscalDeviceOptions((data?.data || []).map(toOption));
        } catch (err) {
          setFiscalDeviceOptions([]);
        }
      };
      loadDefaultOptions();
    } else {
      setFiscalDevice(null);
    }
  }, [modalOpen]);

  const loadFiscalDeviceOptions = _.debounce((searchTerm, callback) => {
    fiscalDeviceService
      .fetchFiscalDevices(1, 15, searchTerm)
      .then(({ data }) => callback((data?.data || []).map(toOption)))
      .catch(() => callback([]));
  }, 300);

  const onSubmit = async () => {
    if (saving) {
      return;
    }
    if (!fiscalDevice?.value?.id) {
      toast.error("Molimo izaberite fiskalni uređaj");
      return;
    }
    try {
      setSaving(true);
      await vendingControllersService.bulkReassignVendingControllers({
        vendingControllerIds: selectedControllers.map(
          (controller) => controller.id
        ),
        fiscalDeviceId: fiscalDevice.value.id,
      });
      toast.info("Sacuvano");
      setFiscalDevice(null);
      onSuccess();
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Greška pri promeni fiskalnog uređaja"
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={modalOpen} onClose={onClose}>
      <div className={styles.modalWrap}>
        <div className={styles.modalInner}>
          <div className={styles.header}>
            <div className={styles.closeIconWrap}>
              <img
                src={CloseIcon}
                alt="close"
                onClick={onClose}
                className={styles.closeIcon}
              />
            </div>
            <p className={styles.title}>
              Promeni fiskalni uređaj ({selectedControllers.length})
            </p>
          </div>
          <div className={styles.content}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Fiskalni uređaj</label>
              <AsyncSelect
                loadOptions={loadFiscalDeviceOptions}
                defaultOptions={fiscalDeviceOptions}
                onChange={setFiscalDevice}
                value={fiscalDevice}
                placeholder="Pretraži fiskalne uređaje..."
                noOptionsMessage={() => "Nema rezultata"}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: "100%",
                  }),
                }}
              />
            </div>
            {fiscalDevice && (
              <p className={styles.confirmText}>
                Prebacuješ {selectedControllers.length} ESP{" "}
                {selectedControllers.length === 1 ? "uređaj" : "uređaja"} na:{" "}
                <b>{fiscalDevice.label}</b>
              </p>
            )}
            <div className={styles.actions}>
              <Button
                name={saving ? "Čuvanje..." : "Sačuvaj"}
                onClick={onSubmit}
                disabled={saving || selectedControllers.length === 0}
                showLoader={saving}
              />
              <Button name="Otkaži" onClick={onClose} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BulkReassignVendingControllersModal;
